import { DashboardModule } from '@domain-group/suit-theme'

import useActivities from '@hooks/useActivities'

import type { EntityOptions } from '@redux/modules/types'

import BlankState from '@components/BlankState'

import ActivityItem from './ActivityItem'

import ActivityImageUrl from './assets/activity.svg'

interface ActivityProps {
  requestOptions?: EntityOptions,
  subjectId: number,
  subjectType: string,
}

const Activity = (props: ActivityProps) => {
  const { requestOptions, subjectId, subjectType } = props

  const activitiesPayload = useActivities({
    filters: {
      recipient_type: subjectType,
      recipient_id: subjectId,
    },
    performHttpRequests: !!subjectId,
    requestOptions,
  })

  const { filteredActivities, filteredActivitiesCount, hasFilteredActivities } = activitiesPayload

  return (
    <DashboardModule.ScrollableSection
      alignItems={hasFilteredActivities ? undefined : 'center'}
      flexDirection="column"
      justifyContent={hasFilteredActivities ? undefined : 'center'}
      marginTop="large"
      maxHeight={600}
    >
      {!hasFilteredActivities && (
        <BlankState
          imageUrl={ActivityImageUrl}
          title="No Activity"
          subtitle="Activity will be logged here once work starts."
        />
      )}

      {filteredActivities.map((activity, index) => (
        <ActivityItem key={activity.id} activity={activity} isLastActivity={index === (filteredActivitiesCount - 1)} />
      ))}
    </DashboardModule.ScrollableSection>
  )
}

export default Activity
